import React, { useState } from 'react';
import { Form, Transition, Document } from 'components';
import { api, isEmail } from 'helpers';
import css from './short.scss';

export function Contact(props) {
  const [ state, setState ] = useState({});

  async function submit({ values, setError, setPending, redirect }) {
    if (!values.email) {
      return setError('email', 'please enter your email');
    } else if (!isEmail(values.email)) {
      return setError('email', 'please enter valid email');
    } else if (!values.message) {
      return setError('message', 'please enter your message');
    }

    setPending();

    try {

      await api('/contact-us/', {
        type: 'contact',
        name: values.name,
        email: values.email,
        comment: values.message,
      });

      redirect('/contact/thank-you/');

    } catch ({ error }) {
      setError('message', 'Server error. Please try again later');
    }

    setPending(false);
  }

  return (
    <Transition in={props.active} mountOnEnter unmountOnExit classNames={css.locals} timeout={500}>
      <Form onSubmit={submit} state={state} setState={setState} className={css('form', 'appear'+props.status)} autoComplete="off">
        <Document.Title>Contact</Document.Title>
        <Document.Description>Please tell us what is your comment or question. We will reply within 24 hours.</Document.Description>
        <h3>Contact us</h3>
        <p><Form.Text name="email" label="Email" /></p>
        <p><Form.Text name="name" label="Name" /></p>
        <p><Form.Textarea name="message" label="Message" /></p>
        <p className={css.tip}>Please tell us what is your comment or question. <br /> We will reply within 24 hours.</p>
        <p><Form.Submit>Send</Form.Submit></p>
      </Form>
    </Transition>
  );
}
